import { z } from "zod";

export const connectDevicesToProviderPayloadSchema = z.object({
  data: z.array(
    z.object({
      vehicleUuid: z.uuid(),
      registrationNumber: z.string(),
      deviceId: z.string(),
      updatedBy: z.string(),
      vin: z.string().optional(),
      brand: z.string().nullable().optional(),
      companyUuid: z.uuid().optional(),
      departmentUuid: z.uuid().nullable().optional(),
    }),
  ),
});

export type ConnectDevicesToProviderPayload = z.infer<
  typeof connectDevicesToProviderPayloadSchema
>;
